import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CrateComments } from '../../../../../models/CrateComments';
import { buildHttpParams } from '../../../../../app/helpers/build-state-params';

@Injectable({
  providedIn: 'root'
})
export class V3CrateCommentsDataSourceService {
  private _baseUrl = `${environment.v3BaseUrl}/api/v3/admin-desktop/crates-comments/count`;

  constructor(private http: HttpClient) { }

  getAll(crateIds: string[]) {
    const queryParams = { cratesIds: crateIds };
    const params = buildHttpParams(queryParams);
    return this.http.get<CrateComments[]>(`${this._baseUrl}`, { params });
  }
} 